import { useState, useEffect } from 'react';
import { useMediaDeviceRepository } from './useMediaDeviceRepository';
import { MediaDeviceStatusError } from 'core/repositories/MediaDeviceRepository';

export function useMediaDeviceStatusError() {
    const [error, setError] = useState<MediaDeviceStatusError>();

    const repository = useMediaDeviceRepository();

    useEffect(() => {
        const listener = (error: MediaDeviceStatusError) => {
            setError(error);
        };

        repository.addMediaDeviceStatusErrorListener(listener);
        return () => {
            repository.removeMediaDeviceStatusErrorListener(listener);
        };
    }, [repository]);

    return error;
}
